import { ComponentUtils } from '@/mixins';
import IconListToChooseFrom from '../Common/IconListToChooseFrom';
import LayoutForSingleConfigurationRow from '../Common/LayoutForSingleConfigurationRow';

// @vue/component
export default {
  name: 'WidgetButtonConfiguration',

  components: {
    IconListToChooseFrom,
    LayoutForSingleConfigurationRow,
  },

  mixins: [ComponentUtils],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    widget: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    icons() {
      return this.$store.getters['settings/buttonIcons'];
    },
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
  },

  created() {
    this.$store.dispatch('settings/getButtonIconsList');
    this.mMakeCopyFromProps('widget');
  },

  methods: {
    handleSelectIcon(iconId, iconImage) {
      this.mCopy.widget.style.button_icons_definition_id_fk = iconId;
      this.mCopy.widget.icon = iconImage;
      this.updateWidget();
    },
    updateWidget() {
      const newWidgetDetails = this.mCopy.widget;
      this.$store.dispatch('widgets/updateWidget', { newWidgetDetails });
    },
  },
};
